import Login from "./login";
// import LoginVR from "./VRNEW/login";
import 'bootstrap/dist/css/bootstrap.min.css';
sessionStorage.setItem('Apipathurl','https://trackhr.co.in/HPM/')
function App() {
  return (
    <Login />
  );
}

export default App;
